/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Field_Client_Id_HintInputs */



/**
* | output |
* | --- |
* | "Only needed if the server does not register clients automatically." |
*
* @param {Mcp_Servers_Field_Client_Id_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_field_client_id_hint = /** @type {((inputs?: Mcp_Servers_Field_Client_Id_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Field_Client_Id_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur nötig, wenn der Server Clients nicht automatisch registriert.")
	return /** @type {LocalizedString} */ ("Only needed if the server does not register clients automatically.")
});